// vue-ls 中存储数据类型

// 框架显示配置
export const SETTINGS_LS = {
  PRIMARY_COLOR: 'primary_color',
  NAV_THEME: 'nav_theme',
  LAYOUT: 'layout',
  COLOR_WEAK: 'color_weak',
  FIXED_HEADER: 'fixed_header',
  FIXED_SIDE_MENU: 'fixed_side_menu',
  CONTENT_WIDTH_TYPE: 'content_width_type',
  MULTI_TAB: 'multi_tab'
}

// 用户信息
export const TOKEN = 'token'
export const USER_INFO = 'user_info'
export const PERMISSIONS = 'permissions'
export const ROLES = 'roles'

// 国际化语言
export const APP_LANGUAGE = 'app_language'
